import React from 'react';
import './Chooseyourpallet.css';


const Chooseyourpallet = () => {
    return (
        <div className="Rotaryinj-container">
            <div className='Ordinarys'>
                <h2 className="Rotaryinj-title">Let’s take a look at how to choose your pallet size:</h2>
                <div className="Rotaryinj-content">
                    <ul className="Rotaryinj-text">
                        <li>1100mmX1100mm this size pallet is an ISO international standard container,
                            the fit rate is very high and suitable for container size, forklift loading
                            and unloading pallet can be a one-way fork, so the bottom shape of
                            the pallet structure is simple, and the pallet quality and strength is
                            better, but also convenient for container loading and unloading operations.
                            However, the size of this kind of pallet is incompatible with
                            the packaging module of most mainstream products,
                            and it is difficult for the product to be stacked neatly on the pallet.</li>
                        <li>1200mmX800mm this size pallet is suitable for the product packaging module because
                            the world’s mainstream product packaging module standard is 600mmX400mm,
                            but the product export also needs to adapt to
                            the container size of the 1200mmX1000m standard specification pallet.</li>
                        <li>1200mmX1000mm specification pallet not only adapts to the size of sea containers,
                            but also adapts to the mainstream product packaging module,
                            and is the most widely used in the world, so
                            this standard size pallet is the world’s most common standard specification.</li>
                        <li>1219 mm×1016 mm pallets are mainly used in the United States,
                            and now the 1200mm X1000mm
                            have also been accepted by many companies in the United States.</li>
                    </ul>
                    
                    <p className="Rotaryinj-text">Pallets flow with the goods between producers,
                        wholesalers, sellers, and users.
                        This flow of pallets results in several advantages in pallet size:</p>
                    <ul className="Rotaryinj-text">
                        <li>It should be applied to the product packaging module to ensure that the pallet has the best loading efficiency;.</li>
                        <li>It should be adapted to the size of various forklifts to optimize the loading and unloading efficiency;</li>
                        <li>It should be adapted to the shelf specifications to improve storage efficiency;</li>
                        <li>It should be adapted to the specifications of freight cars, train caravans, and containers to
                            improve transportation efficiency.</li>
                    </ul>
                    <p className="Rotaryinj-text">Disha large two-platen injection molding machines can meet
                        the plastic pallet production requirements of different size standards.</p>
                </div>
            </div>
        </div>
    );
};

export default Chooseyourpallet;
